"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Controlla se il valore è definito
 *
 * @param {*} value
 * @returns {boolean}
 */
exports.isDef = (value) => {
    return typeof value !== 'undefined';
};
/**
 * Controlla se il valore non è definito
 *
 * @param {*} value
 * @returns {boolean}
 */
exports.isUndef = (value) => {
    return !exports.isDef(value);
};
/**
 * Controlla se {a} è uguale a {b}.
 * Verranno controllate anche le proprietà innestate.
 *
 * @param {*} a
 * @param {*} b
 * @returns {boolean}
 */
exports.isEqual = (a, b) => {
    if (typeof a !== 'object' || a === null || b === null) {
        return a === b;
    }
    else {
        const keys = Object.keys(a);
        for (let i = 0, len = keys.length; i < len; i++)
            if (typeof b[keys[i]] === 'undefined' || !exports.isEqual(a[keys[i]], b[keys[i]]))
                return false;
    }
    return true;
};
/**
 * Mappa un oggetto
 *
 * @param {object} object
 * @param {(value: any, key: string, index: number) => any} callable
 * @returns {Object}
 */
exports.map = (object, callable) => {
    Object.keys(object).forEach((key, index) => {
        object[key] = callable(object[key], key, index);
    });
    return object;
};
/**
 * Scorre un oggetto
 *
 * @param {object} object
 * @param {(value: any, key: string, index: number) => any} callable
 */
exports.each = (object, callable) => {
    Object.keys(object).forEach((key, index) => {
        callable(object[key], key, index);
    });
};
/**
 * Controlla se una proprietà esiste nell'oggetto {object}
 *
 * @example
 * ```javascript
 *
 * const data = { key: 'mykey', items: [] }
 * console.log(object.hasProperty(data, 'items')) // true
 * ```
 *
 * @param {object} object
 * @param {string} property
 * @returns {boolean}
 */
exports.hasProperty = (object, property) => {
    return typeof this.getProperty(object, property, undefined) !== 'undefined';
};
/**
 * Ritorna la proprietà di un oggetto
 *
 * @example
 * ```javascript
 *
 * const data = { key: 'mykey', items: [{ id: 1, name: 'Foo' }, { id: 2, name: 'Bar' }] }
 * console.log(utility.object.getProperty(data, 'items.1.name')) // Bar
 * ```
 *
 * @param {object} object
 * @param {string} property
 * @param {*} [defaultValue=null]
 * @returns
 */
exports.getProperty = (object, property, defaultValue = null) => {
    const properties = property.split('.');
    const len = properties.length;
    for (let i = 0; i < len; i++) {
        const p = properties[i];
        const pi = parseInt(p);
        if (p == '*' && Array.isArray(object))
            return object.map(o => this.getProperty(o, properties.slice(i + 1).join('.'), defaultValue));
        if (!isNaN(pi) && Array.isArray(object))
            return this.getProperty(object[i], properties.slice(i + 1).join('.'), defaultValue);
        if (!object.hasOwnProperty(p))
            return defaultValue;
        object = object[p];
        if (typeof object === 'undefined')
            return defaultValue;
    }
    return object;
};
/**
 * Setta più proprietà in un oggetto
 *
 * @example
 * ```javascript
 *
 * const data = { }
 * utility.object.setProperties(data, ['a', 'b'], [1, [2, 3]])
 * console.log(data) // { a: 1, b: [ 2, 3 ] }
 * ```
 *
 * @param {object} object
 * @param {Array<string>} properties
 * @param {(Array<any> | Function | any)} values
 */
exports.setProperties = (object, properties, values) => {
    properties.forEach((property, index) => {
        let temp = object;
        const nestedProperties = property.split('.');
        const setPropery = nestedProperties.pop();
        nestedProperties.forEach(p => { temp = temp[p] || {}; });
        temp[setPropery] = Array.isArray(values) ? values[index] : typeof values === 'function' ? values(temp[setPropery]) : values;
    });
};
//# sourceMappingURL=Object.js.map